import nexaLogoImg from '../images/nexalogo.png';

export const NexaLogoIcon = ({ size = 38, className = "" }) => (
  <img
    src={nexaLogoImg}
    alt="NexaAI Logo"
    width={size}
    height={size}
    className={`nexa-logo-img ${className}`}
    style={{
      width: `${size}px`,
      height: `${size}px`,
      objectFit: 'contain',
      display: 'block',
      filter: 'drop-shadow(0 3px 10px rgba(255, 85, 0, 0.25))'
    }}
  />
);

export default NexaLogoIcon;
